module.exports = __webpack_public_path__ + "static/media/sml.9471df3a.png";